import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';
import { selectors as rootSelectors } from '../root';

import Table from './components/table/main';
import Filters from '../shared/filters/main';
import Calendar from '../shared/calendar/main';

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content daily-approve-list">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">{props.intl('Аппрув день в день')}</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className="clearfix position-relative display-flex-column top-navbar-container">
						<Filters {...props} {...props.filters} />
						<div className="display-flex">
							<div className="ui-control-bar__item-position">
								<Calendar
									{...props.calendarOfCreationDate}
									onInit={props.calendarOfCreationDateInit}
									onToggle={props.calendarOfCreationDateToggle}
									onChange={props.calendarOfCreationDateChange}
									onApply={props.calendarOfCreationDateApply}
									intl={props.intl}
								/>
							</div>
							<button
								className="ui-btn ui-btn-primary save margin-left-10"
								onClick={props.fetchData}
							>
								{props.intl('Apply')}
							</button>
						</div>
					</div>

					<Table {...props} />
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		isRequestForApprovePopupVisible: selectors.getIsRequestForApprovePopupVisible(state),
		calendarOfCreationDate: selectors.getCalendarOfCreationDate(state),
		manualApproveInitialValues: selectors.getManualApproveInitialValues(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		progressBar: selectors.getProgressBar(state),
		intl: selectors.getIntl(state),
		filters: selectors.getFilters(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/daily-approves-list/main.js